/*
 *   Shows the contents/children when the spinner disappears
 */

import React, { useEffect, useState } from 'react';

import { useIsBusy } from '../data/hooks/ui/useIsBusy';
import PleaseWait from './screens/PleaseWait';

const WaitWhileBusy = (props) => {
    const { children = null, alt } = props,
        busy = useIsBusy(),
        [ready, setReady] = useState(!busy);

    useEffect(() => {
        if (!ready && !busy) {
            setReady(true);
        }
    }, [busy]);

    if (!ready) return alt || <PleaseWait />;

    return children;
};

export default WaitWhileBusy;
